module.exports = __webpack_public_path__ + "static/media/code-commit.18c486a2.svg";